import { cn } from "@faire/react/tools/cn";
import React, { InputHTMLAttributes } from "react";

type IProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "aria-checked" | "role" | "type"
> & {
  "data-component-name"?: string;
};

export const ToggleBase: React.FC<IProps> = ({
  checked,
  className,
  "data-component-name": dataComponentName,
  ...props
}) => (
  <div
    className={cn("fs-toggle", className)}
    data-component-name={dataComponentName}
  >
    <input
      {...props}
      aria-checked={checked}
      checked={checked}
      className="fs-toggle__input focusable"
      role="switch"
      type="checkbox"
    />
  </div>
);
